// extracted by mini-css-extract-plugin
export var $animation_name = "KlaviyoEmbed-module--$animation_name--aa51d";
export var klaviyoEmbed = "KlaviyoEmbed-module--klaviyoEmbed--2584b";
export var klaviyoEmbed__black = "KlaviyoEmbed-module--klaviyoEmbed__black--e8c1f";
export var klaviyoEmbed__red = "KlaviyoEmbed-module--klaviyoEmbed__red--11c34";
export var klaviyoEmbed__yellow = "KlaviyoEmbed-module--klaviyoEmbed__yellow--b419e";